import { Group, Button, Text, Select } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useTranslation } from '../hooks/useTranslation';

export function Navbar() {
  const { user, logout, isLoggingOut } = useAuth();
  const location = useLocation();
  const { t, changeLanguage, currentLanguage } = useTranslation();

  return (
    <Group justify="space-between" p="md" style={{ borderBottom: '1px solid #eee' }}>
      <Group>
        <Text fw={500} size="lg">
          {t('navigation.appTitle')}
        </Text>
        <Group gap="xs" ml="xl">
          <Button
            component={Link}
            to="/"
            variant={location.pathname === '/' ? 'filled' : 'subtle'}
            size="sm"
          >
            {t('navigation.equipment')}
          </Button>
          <Button
            component={Link}
            to="/reports"
            variant={location.pathname === '/reports' ? 'filled' : 'subtle'}
            size="sm"
          >
            {t('navigation.reports')}
          </Button>
          <Button
            component={Link}
            to="/configuration"
            variant={location.pathname === '/configuration' ? 'filled' : 'subtle'}
            size="sm"
          >
            {t('navigation.configuration')}
          </Button>
        </Group>
      </Group>
      <Group>
        <Text size="sm" c="dimmed">
          {user?.firstName} {user?.lastName}
        </Text>
        <Select
          value={currentLanguage}
          onChange={(value) => value && changeLanguage(value)}
          data={[
            { value: 'fr', label: 'Français' }
          ]}
          size="sm"
          w={120}
          aria-label={t('navigation.language')}
        />
        <Button variant="light" onClick={() => logout()} loading={isLoggingOut}>
          {t('navigation.logout')}
        </Button>
      </Group>
    </Group>
  );
} 